export default __webpack_public_path__ + "static/taskdefinition14-b4172740449c57eadf4a8fba3354ee1b.png";